import React from 'react';
import { useIndustryQuery } from 'api';
import { Col, CountrySelect, Form, FormModal, Input, Row, Select } from 'components';
import { ValidationErrors } from 'constants/validations';
import { useAddBrand } from './useAddBrand';
import { webSiteUrlRegex } from 'utils/helpers';

const { Item } = Form;
const { TextArea } = Input;

export interface IAddBrandModal {
  modalState: boolean;
  onModalStateChange: () => void;
}

export const AddBrandModal: React.FC<IAddBrandModal> = (props) => {
  const { onModalStateChange, modalState } = props;
  const { data: industryData = [] } = useIndustryQuery();
  const { onFinish, form, onCancel, contextHolder, isLoading } = useAddBrand({ onModalStateChange });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Add Brand'}
        okText={'Add'}
        open={modalState}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Item
                  label={'Brand Name*'}
                  name={'name'}
                  rules={[{ required: true, message: ValidationErrors.required('Brand Name') }]}
                >
                  <Input size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  name="countryId"
                  label={'Country*'}
                  rules={[
                    {
                      required: true,
                      message: ValidationErrors.required('Country'),
                    },
                  ]}
                >
                  <CountrySelect size={'large'} maxTagCount={'responsive'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  label={'Industry*'}
                  name={'industryId'}
                  rules={[{ required: true, message: ValidationErrors.required('Industry') }]}
                >
                  <Select options={industryData} size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="manufacturerWebSiteUrl"
                  label={'Manufacturer Website'}
                  rules={[{ pattern: webSiteUrlRegex, message: 'Please enter a valid website URL.' }]}
                >
                  <Input size={'large'} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Item label={'Additional Notes'} name={'additionalNotes'}>
                  <TextArea rows={4} />
                </Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </FormModal>
    </>
  );
};
